import type { EmailBlockData } from '../ModernEmailBuilder';
import type { AIEmailResponse } from '../../../services/aiService';
import { createBlockFromType } from './blockFactory';
import { generateId } from './helpers';

/**
 * Converts AI-generated email structure to EmailBlockData array
 */
export function convertAIEmailToBlocks(aiResponse: AIEmailResponse): EmailBlockData[] {
  const blocks: EmailBlockData[] = [];

  for (const item of aiResponse.bodyStructure) {
    let block: EmailBlockData;

    switch (item.type) {
      case 'heading':
        block = createBlockFromType('heading');
        block.content = {
          text: item.content,
          level: item.level || 1,
        };
        block.styles = {
          ...block.styles,
          padding: '20px 0px 10px 0px',
          fontSize: item.level === 1 ? '32px' : item.level === 2 ? '24px' : '20px',
          fontWeight: '700',
          color: '#111827',
          textAlign: 'left',
        };
        break;

      case 'text':
        block = createBlockFromType('text');
        block.content = {
          text: item.content,
        };
        block.styles = {
          ...block.styles,
          padding: '10px 0px 10px 0px',
          fontSize: '16px',
          lineHeight: '1.6',
          color: '#111827',
          textAlign: 'left',
        };
        break;

      case 'button':
        block = createBlockFromType('button');
        block.content = {
          text: item.buttonText || item.content || 'Click Here',
          url: item.buttonUrl || 'https://example.com',
          actionType: 'open-url',
        };
        block.styles = {
          ...block.styles,
          padding: '20px 0px',
          textAlign: 'center',
          buttonStyle: {
            backgroundColor: '#3B82F6',
            color: '#FFFFFF',
            padding: '12px 24px',
            borderRadius: '6px',
            fontSize: '16px',
            fontWeight: '600',
            width: 'auto',
          },
        };
        break;

      case 'divider':
        block = createBlockFromType('divider');
        block.styles = {
          ...block.styles,
          padding: '20px',
          borderColor: '#E5E7EB',
          borderWidth: '1px',
          borderStyle: 'solid',
        };
        break;

      case 'spacer':
        block = createBlockFromType('spacer');
        block.content = {
          height: '40px',
        };
        break;

      default:
        // Default to text block
        block = createBlockFromType('text');
        block.content = {
          text: item.content || '',
        };
    }

    // Ensure each block has a unique ID
    block.id = generateId();
    blocks.push(block);
  }

  // If no blocks were created, add a default welcome block
  if (blocks.length === 0) {
    const defaultBlock = createBlockFromType('heading');
    defaultBlock.content = {
      text: 'Welcome!',
      level: 1,
    };
    blocks.push(defaultBlock);
  }

  return blocks;
}





